import React, { Component } from 'react';
import Input from '../../ui/input/Input';
import { labels } from './labels';
import countriesData from '../../countries.json';

const styles = {
    fileinput: {
        width: '0.1px',
        height: '0.1px',
        opacity: 0,
        overflow: 'hidden',
        position: 'absolute',
        zIndex: -1
    },
    filelabel: {
        fontSize: '1em',
        fontWeight: 700,
        color: 'white',
        display: 'inline-block',
        padding: '.4em',
        margin: '0 0 .5em 0',
        cursor: 'pointer',
    },
  }

export default class DonationFields extends Component {
    constructor(props) {
        super(props)

        this.state = {
            panelActive: false, 
            countries: "",
        }
    }

    componentDidMount() {
        this.setState({
            countries: countriesData.countries
        })
    }

    togglePanel = () => {
        this.setState({panelActive: this.state.panelActive ? false : true})
    }

    render() {
        return(
            <div className="flex flex-col gap-4 bg-lightgrey rounded my-6 py-8">
                <div className="mx-8">
                    <h3>{labels.header5[this.props.type]}</h3>
                    <p>{labels.text5[this.props.type]}</p>
                    {this.props.data.map((row, rowIndex) => (
                        <div key={rowIndex}>
                            <div className="flex gap-4">
                                <label>
                                    <Input type="text" placeholder="Navn" value={row[1]} error={this.props.type === 'other' && typeof row[1] === 'string' && row[1].toLowerCase() === "Anonym".toLowerCase()} onChange={(e) => this.props.handleInputChange(this.props.type, rowIndex, 1, e.target.value)} />
                                </label>
                                <label>
                                    <div className="flex gap-2">
                                        <Input type="text" minWidth="200" placeholder="Beløb" value={row[0]} error={typeof row[0] === 'string' && parseFloat(row[0].replace(',','.')) < 20000.01} onChange={(e) => this.props.handleInputChange(this.props.type, rowIndex, 0, e.target.value)} /> <span className="self-center">kr.</span></div>
                                </label>
                                {this.props.type === 'other' && 
                                <div>
                                <label>
                                    <Input type="text" placeholder="Vejnavn, postnummer og by" value={row[2]} onChange={(e) => this.props.handleInputChange(this.props.type, rowIndex, 2, e.target.value)} />
                                </label>
                                <label>Vælg land <br/>
                                    <select className="mt-2 p-2 rounded" onChange={(e) => this.props.handleInputChange(this.props.type, rowIndex, 3, e.target.value)}>
                                        <option value=""></option>
                                        {this.state.countries.map((country, index) => (
                                            <option key={index} value={country.name} selected={country.name === row[3]}>
                                                {country.name}
                                            </option>
                                        ))}
                                    </select>
                                </label>
                                </div>
                                }
                                <div>
                                    <button className="button nusmall" onClick={() => this.props.handleDeleteRow(this.props.type, rowIndex)}>
                                        Slet række
                                    </button>
                                </div>
                            </div>
                        </div>
                    ))}
                    <div className="my-6 flex gap-4 justify-between">
                        <button className="button ocean" onClick={() => this.props.handleAddRow(this.props.type)}>Tilføj donation</button>
                        <button className="button" onClick={this.togglePanel}>{this.state.panelActive ? 'Luk' : labels.buttonUploadUsingExcel}</button>
                    </div>

                    {this.state.panelActive && 
                        <UploadPanel 
                            year={this.props.year} 
                            donationsFile={this.props.donationsFile} 
                            uploadDonationFile={() => this.props.uploadDonationFile()} 
                            onChange={this.props.onChange}
                            type={this.props.type} />
                        }
                </div>
            </div>
        )
    }
}

const UploadPanel = (props) => {
    const donationsFile = props.type==="person" ? 'donationsFile1' : 'donationsFile2';
    const disabled = !props.donationsFile;
    
    return(
        <div className="flex flex-col gap-4 bg-white rounded my-6 py-8">
            <div className="mx-8">
                <h2>Upload excelark</h2>
                
                <div className="flex flex-col">
                    <h3>Hent excelskabelon</h3>
                    <a href="https://blkm.dk/arbejdsomraader/andre-trossamfund/adgang-til-trossamfundsregistret/indberetning-til-trossamfundsregistret" target="_blank" className="text-bluegray">Klik for at hente excelskabelon</a>
                </div>

                <div style={{margin: '1.5em 0'}}>
                    <input style={styles.fileinput} id={props.year + props.type} type="file" name={donationsFile} onChange={props.onChange} />
                    <label htmlFor={props.year + props.type} style={styles.filelabel} className="upload">{props.donationsFile ? props.donationsFile.name : 'Vælg fil'}</label>
                    <div className="form-helper-label">Kun excelfiler tilladt.</div>
                </div>

                <button className="button ocean" type="button" disabled={disabled} onClick={() => { if (window.confirm('Bemærk, at du overskriver alle manuelle indtastninger ved upload af fil')) props.uploadDonationFile(props.type)}}>Upload</button>
            </div>
        </div>
    )
}


// WEBPACK FOOTER //
// ./src/modules/reports/DonationsFields.js